import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const GlobalRoutingModelsBasicInfoComponent = ({ routingModel, handleInnerBasicFormChange }: any) => {

  return (<>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerBasicFormChange(
                event.target.value,
                'Name',
              );
            }}
            type="text"
            value={routingModel?.Name}
          />
          <InputContainer
            label="Global Routing Model Code"
            onValueChange={(event: any, newValue: any) => {
              handleInnerBasicFormChange(
                event.target.value,
                'GlobalRoutingModelCode',
              );
            }}
            type="text"
            value={routingModel?.GlobalRoutingModelCode}
          />
        </div>

      }
      expandedPanel="basicInfo"
      headerTitle="Basic Info"
    />
  </>
  )
}
export default GlobalRoutingModelsBasicInfoComponent;
